import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import New from './new';

jest.mock('axios');

describe('CompanyGroup', () => {
  describe('New', () => {
    test('renders', async() => {

      const m_companies = [ {id: 1, company_name: "company_A"} , {id: 2, company_name: "company_B"} ]

      render(<New unselected_companies={m_companies}/>);

      // タイトル
      expect(screen.getByRole("heading", {name: "企業グループ登録"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('登録')).toBeInTheDocument();
      expect(screen.getByText('戻る')).toBeInTheDocument();

      // 企業一覧
      expect(screen.getByText('company_A')).toBeInTheDocument();
      expect(screen.getByText('company_B')).toBeInTheDocument();
    });  
  }); 
});